import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    Show,
    SimpleShowLayout,
    DateField,
    Filter,
    ImageField,
    ImageInput,
    DeleteButton,
} from 'react-admin';

const TeacherFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索" source="key" alwaysOn />
    </Filter>
);

export const TeacherList = props => (
    <List {...props} filters={<TeacherFilter />} title="师资管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <ImageField source="Avatar" label="头像" />
            <TextField source="Name" label="姓名" />
            <TextField source="Title" label="职称" />
            <TextField source="Field" label="专业领域" />
            <TextField source="Phone" label="联系电话" />
            <TextField source="Status" label="状态" />
            <DateField source="CreateTime" label="创建时间" showTime />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const TeacherEdit = props => (
    <Edit {...props} title="编辑师资">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Name" label="姓名" />
            <TextInput source="Avatar" label="头像URL" fullWidth />
            <TextInput source="Title" label="职称" />
            <TextInput source="Field" label="专业领域" />
            <TextInput source="Introduction" label="简介" multiline fullWidth />
            <TextInput source="Phone" label="联系电话" />
            <TextInput source="Email" label="邮箱" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 1, name: '在职' },
                { id: 0, name: '离职' },
            ]} />
        </SimpleForm>
    </Edit>
);

export const TeacherCreate = props => (
    <Create {...props} title="新建师资">
        <SimpleForm>
            <TextInput source="Name" label="姓名" />
            <TextInput source="Avatar" label="头像URL" fullWidth />
            <TextInput source="Title" label="职称" />
            <TextInput source="Field" label="专业领域" />
            <TextInput source="Introduction" label="简介" multiline fullWidth />
            <TextInput source="Phone" label="联系电话" />
            <TextInput source="Email" label="邮箱" />
            <SelectInput source="Status" label="状态" defaultValue={1} choices={[
                { id: 1, name: '在职' },
                { id: 0, name: '离职' },
            ]} />
        </SimpleForm>
    </Create>
);
